/**
 * ElevationProfilePlugin — profile tool backed by terrain elevation sampling.
 *
 * Integrates the cross-section-line draw mode with the
 * `elevationProfileSampler` and renders results in the
 * `ElevationProfileChart`.
 */

import type { AnnotationEntry } from '@geosoft/viewer-sdk';

export interface ElevationProfilePluginState {
  readonly status: 'idle' | 'drawing' | 'sampled';
  readonly startCoord: [number, number] | null;
  readonly endCoord: [number, number] | null;
  readonly sampleCount: number;
}

export const INITIAL_STATE: ElevationProfilePluginState = {
  status: 'idle',
  startCoord: null,
  endCoord: null,
  sampleCount: 64,
};

export function extractProfileCoords(
  annotations: ReadonlyArray<AnnotationEntry>,
): { start: [number, number]; end: [number, number] } | null {
  const crossSection = annotations.find(
    (a) =>
      a.kind === 'geo:cross-section-line' && a.geometry.type === 'LineString',
  );

  if (!crossSection || crossSection.geometry.type !== 'LineString') {
    return null;
  }

  const coords = crossSection.geometry.coordinates as Array<[number, number]>;
  if (coords.length < 2) return null;

  return {
    start: coords[0],
    end: coords[coords.length - 1],
  };
}
